module.exports = __webpack_public_path__ + "img/b.bee4c33e.jpg";